import type { FC } from "react";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserList from "../components/userlist";
import RegisterUser from "../components/registeruser";
import RegisterGroup from "../components/registergroup";
import GroupList from "../components/grouplist";
import AppContext from "../utils/appContext";
import Footer from "../components/footer";
import { Button, Modal, PageShell, Toolbar } from "../components/ui";

const Users: FC = () => {
  const [counter, setCounter] = useState(0);
  const [user] = useState(JSON.parse(localStorage.getItem("user") || "{}"));
  const [groups, setGroups] = useState<Array<any>>([]);
  const [showRegisterUser, setShowRegisterUser] = useState(false);
  const [showRegisterGroup, setShowRegisterGroup] = useState(false);
  const [showManageGroups, setShowManageGroups] = useState(false);
  const context = useContext(AppContext);
  const navigate = useNavigate();

  const updateCounter = () => {
    setCounter(counter + 1);
  };
  const checkStatus = async () => {
    const storedJWT = localStorage.getItem("jwt");

    if (storedJWT) {
      await fetch(process.env.REACT_APP_API_URL + "/check-status.php", {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + storedJWT,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === "success") {
          } else {
            localStorage.clear();
            context?.updateLoginStatus(false);
            navigate("/login");
          }
        })
        .catch((error) => {
          // Handle network or server errors
          console.error();
          localStorage.clear();
          context?.updateLoginStatus(false);
          navigate("/login");
        });
    } else {
      localStorage.clear();
      context?.updateLoginStatus(false);
      navigate("/login");
    }
  };
  const getgroups = async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-all-groups.php", {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setGroups(data);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const toggleRegisterUserModal = () => {
    setShowRegisterUser(!showRegisterUser);
  };
  const toggleRegisterGroupModal = () => {
    setShowRegisterGroup(!showRegisterGroup);
  };
  const toggleManageGroupsModal = () => {
    setShowManageGroups(!showManageGroups);
  };
  useEffect(() => {
    if (user.groups?.includes(0) || user.groups?.includes(1)) {
      getgroups();
    }
    checkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const roles = JSON.parse(user.groups || "[]");

  return (
    <>
      <PageShell>
        <Toolbar className="mb-3">
          {process.env.REACT_APP_USERS_CAN_CREATE_USER === "true" && (
            <Button onClick={toggleRegisterUserModal}>Register a user</Button>
          )}
          {process.env.REACT_APP_USERS_CAN_CREATE_GROUP === "true" && (
            <Button onClick={toggleRegisterGroupModal}>Create a group</Button>
          )}
          {process.env.REACT_APP_USERS_CAN_MANAGE_GROUP === "true" && (
            <Button onClick={toggleManageGroupsModal}>Manage groups</Button>
          )}
        </Toolbar>
        <UserList refreshCounter={counter} groups={groups} />
        {(roles?.includes(0) || roles?.includes(1)) && showRegisterUser && (
          <Modal isOpen={showRegisterUser} maxWidth="md">
            <RegisterUser
              groups={groups}
              toggleRegisterUserModal={toggleRegisterUserModal}
              refresh={updateCounter}
            />
          </Modal>
        )}
        {roles?.includes(0) && showRegisterGroup && (
          <Modal isOpen={showRegisterGroup} maxWidth="md">
            <RegisterGroup
              toggleRegisterGroupModal={toggleRegisterGroupModal}
              refresh={updateCounter}
            />
          </Modal>
        )}
        {roles?.includes(0) && showManageGroups && (
          <Modal isOpen={showManageGroups} maxWidth="md">
            <GroupList
              toggleManageGroupsModal={toggleManageGroupsModal}
              refreshCounter={counter}
            />
          </Modal>
        )}
      </PageShell>
      <Footer />
    </>
  );
};
export default Users;
